import { setConfiguration, saveConfiguration } from "./lib/configuration";
import { removeCookies } from "./lib/remove-cookies";
// import { insertScriptFilter } from './lib/insert-script-filter'
// import { filterTags } from './lib/script-tag-filter'
// import { wrapperFilter } from './lib/wrapper-filter'
// import { filterlocalCookies } from './lib/local-cookie-filter'

import {
  SAFE_INIT_COOKIE,
  CONSENTIMENTO_COOKIES,
  CONFIGURACOES_CCONSENTMANAGER,
} from "./defaults/settings";

const CConsentManager = (function () {
  const eventsCallback = { updateVisibility: null, updateConsent: null };

  function addEventListener(eventName, cb) {
    if (eventName in eventsCallback) {
      if (Array.isArray(eventsCallback[eventName])) {
        eventsCallback[eventName].push(cb);
      } else {
        eventsCallback[eventName] = [cb];
      }
    } else {
      console.error(
        `[CConsentManager] The "${eventName}" event is not available`
      );
    }
  }

  function checkConsent(searchWord) {
    const services = window.CConsentManager._services;
    if (!services || (Array.isArray(services) && !services.length)) {
      return false;
    }

    for (const service of services) {
      if (service.search === searchWord) {
        return service.wanted;
      }
    }

    return undefined;
  }

  function configure(configObject) {
    let _showPopup = false;

    window.CConsentManager.buffer = {
      appendChild: [],
      insertBefore: [],
    };

    // Wrapper filter function
    window.CConsentManager.wrapper = function () {};

    window.CConsentManager.loadWantedScripts = writeBufferToDOM;

    window.CConsentManager.save = () => {
      saveConfiguration();
      removeCookies();
      writeBufferToDOM();
      if (window.CConsentManager.config.hideOnSave) {
        window.CConsentManager.config.showPopup = false;
      }
    };

    window.CConsentManager.config = {
      active: true,
      cookieName: CONSENTIMENTO_COOKIES,
      rootDomain: `.${process.env.MIX_ROOT_DOMAIN}`,
      hideOnSave: true,
      showOnInit: true,
      cookieExists: false,
      showPopup: false,
      cookieVersion: 1.2,
      categories: [],
      set showPopup(val) {
        if (Array.isArray(eventsCallback.updateVisibility)) {
          eventsCallback.updateVisibility.forEach((cb) => {
            if (typeof cb === "function") {
              cb(val);
            }
          });
        }
        _showPopup = val;
      },
      get showPopup() {
        return _showPopup;
      },
    };

    setConfiguration(configObject);
  }

  function writeBufferToDOM() {
    window.CConsentManager.buffer.appendChild.forEach((action) => {
      if (action.service.wanted) {
        Node.prototype.appendChild.apply(action.this, action.arguments);
      }
    });

    window.CConsentManager.buffer.insertBefore.forEach((action) => {
      if (action.service.wanted) {
        action.arguments[1] =
          action.arguments[0].parentNode === null
            ? action.this.lastChild
            : action.arguments[1];
        Node.prototype.insertBefore.apply(action.this, action.arguments);
      }
    });
  }

  function loadAllWantedScripts() {
    const everythingLoaded = setInterval(() => {
      if (/loaded|complete/.test(document.readyState)) {
        clearInterval(everythingLoaded);
        window.CConsentManager.loadWantedScripts();
      }
    }, 50);
  }

  return {
    addEventListener,
    safeInit(configObject) {
      const cookie = document.cookie
        .split(";")
        .find((cstr) => cstr.includes(SAFE_INIT_COOKIE));

      if (cookie) {
        const value = JSON.parse(decodeURIComponent(cookie.split("=")[1]));
        if (value) {
          window.CConsentManager.init(configObject);
        }
      }
    },
    checkConsent,
    init(configObject) {
      configure(configObject);
      removeCookies();
      // insertScriptFilter()
      // filterTags()
      // wrapperFilter()
      // filterlocalCookies()
      // loadAllWantedScripts()

      const { cookieExists, showOnInit } = window.CConsentManager.config;
      if (!cookieExists && showOnInit) {
        window.CConsentManager.config.showPopup = true;
      }
    },
  };
})();

window.CConsentManager = window.CConsentManager || {};
window.CConsentManager.addEventListener = CConsentManager.addEventListener;
window.CConsentManager.checkConsent = CConsentManager.checkConsent;
window.CConsentManager.init = CConsentManager.init;
window.CConsentManager.safeInit = CConsentManager.safeInit;

// window.CConsentManager.safeInit(CONFIGURACOES_CCONSENTMANAGER)

window.CConsentManager.init(CONFIGURACOES_CCONSENTMANAGER);
